(function () {
  'use strict';

  function createGroup(labelText, control) {
    var group = document.createElement('div');
    group.className = 'contact-form__group';

    var label = document.createElement('label');
    label.className = 'contact-form__label';
    label.htmlFor = control.id;
    label.textContent = labelText;

    group.appendChild(label);
    group.appendChild(control);
    return group;
  }

  function createSelect(id, name, placeholder, options, required) {
    var select = document.createElement('select');
    select.id = id;
    select.name = name;
    select.className = 'contact-form__input';
    select.required = Boolean(required);
    if (required) select.setAttribute('aria-required', 'true');

    var prompt = document.createElement('option');
    prompt.value = '';
    prompt.textContent = placeholder;
    prompt.disabled = true;
    prompt.selected = true;
    select.appendChild(prompt);

    options.forEach(function (optionData) {
      var option = document.createElement('option');
      option.value = optionData[0];
      option.textContent = optionData[1];
      select.appendChild(option);
    });
    return select;
  }

  function hiddenField(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value || '';
    form.appendChild(input);
  }

  function campaignData() {
    var params = new URLSearchParams(window.location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
    var values = [];
    keys.forEach(function (key) {
      var value = params.get(key);
      if (value) values.push(key + ': ' + value);
    });
    return values.join(' | ');
  }

  function enhanceGermanContactForm() {
    if (window.location.pathname.replace(/\/$/, '') !== '/de/pages/contact') return;

    var form = document.getElementById('ContactPageForm');
    if (!form || form.dataset.florixEnhanced === 'true') return;

    var message = form.querySelector('#ContactMessage');
    var messageGroup = message ? message.closest('.contact-form__group') : null;
    if (!messageGroup) return;

    var category = createSelect(
      'ContactProductCategory',
      'contact[Produktkategorie]',
      'Produktkategorie auswählen',
      [
        ['Sportswear & Teamwear', 'Sport- und Teambekleidung'],
        ['Gym Wear & Activewear', 'Gymwear und Activewear'],
        ['Tracksuits & Joggers', 'Trainingsanzüge und Jogginghosen'],
        ['Hoodies & Sweatshirts', 'Hoodies und Sweatshirts'],
        ['T-Shirts', 'T-Shirts'],
        ['Leather Jackets', 'Lederjacken'],
        ['Varsity & Bomber Jackets', 'College- und Bomberjacken'],
        ['Uniforms & Workwear', 'Uniformen und Arbeitskleidung'],
        ['Denim', 'Denim'],
        ['Martial Arts & Combat Sportswear', 'Kampfsportbekleidung'],
        ['Motorsport Apparel', 'Motorsportbekleidung'],
        ['Caps, Bags & Accessories', 'Caps, Taschen und Accessoires'],
        ['Private Label Clothing', 'Private-Label-Bekleidung'],
        ['Other', 'Sonstiges']
      ],
      true
    );

    var quantity = createSelect(
      'ContactQuantity',
      'contact[Geschätzte Menge]',
      'Geschätzte Menge auswählen',
      [
        ['Sample only', 'Nur Muster'],
        ['5–25 pieces', '5–25 Stück'],
        ['26–100 pieces', '26–100 Stück'],
        ['101–500 pieces', '101–500 Stück'],
        ['501–1,000 pieces', '501–1.000 Stück'],
        ['1,000+ pieces', 'Mehr als 1.000 Stück']
      ],
      true
    );

    var country = document.createElement('input');
    country.id = 'ContactDeliveryCountry';
    country.type = 'text';
    country.name = 'contact[Lieferland]';
    country.className = 'contact-form__input';
    country.placeholder = 'Deutschland';
    country.autocomplete = 'country-name';
    country.required = true;
    country.setAttribute('aria-required', 'true');

    var deadline = document.createElement('input');
    deadline.id = 'ContactTargetDate';
    deadline.type = 'date';
    deadline.name = 'contact[Zieldatum]';
    deadline.className = 'contact-form__input';
    deadline.min = new Date().toISOString().split('T')[0];

    var rowOne = document.createElement('div');
    rowOne.className = 'contact-form__row';
    rowOne.appendChild(createGroup('Produktkategorie *', category));
    rowOne.appendChild(createGroup('Geschätzte Menge *', quantity));

    var rowTwo = document.createElement('div');
    rowTwo.className = 'contact-form__row';
    rowTwo.appendChild(createGroup('Lieferland *', country));
    rowTwo.appendChild(createGroup('Zieldatum / Frist', deadline));

    form.insertBefore(rowOne, messageGroup);
    form.insertBefore(rowTwo, messageGroup);

    message.placeholder = 'Beschreiben Sie Produkt, Stoff oder GSM, Größen, Farben, Branding, Verpackung und Referenzdesigns.';

    var submit = form.querySelector('.contact-form__submit');
    if (submit) {
      Array.from(submit.childNodes).some(function (node) {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
          node.nodeValue = '\n            Fertigungsangebot anfordern\n          ';
          return true;
        }
        return false;
      });
    }

    var canonical = document.querySelector('link[rel="canonical"]');
    hiddenField(form, 'contact[Anfragetyp]', 'Fertigungsangebot');
    hiddenField(form, 'contact[Quellseite]', window.location.pathname);
    hiddenField(form, 'contact[Quell-URL]', canonical ? canonical.href : window.location.href.split('#')[0]);
    hiddenField(form, 'contact[Vorherige Seite]', document.referrer || 'Direkt / nicht verfügbar');
    hiddenField(form, 'contact[Kampagnendaten]', campaignData() || 'Keine erfasst');

    form.dataset.florixEnhanced = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceGermanContactForm);
  } else {
    enhanceGermanContactForm();
  }
})();
